//var nj = require('numjs');
const math = require('mathjs'); //install using "npm install mathjs"

export default {
    data: {
      paused : true,
    
      width : 380, //380
      height : 380,  //380
      timerDelay : 0, // milliseconds

      r : -1,
      c : -1,
      size : 10,
      state : math.zeros(10, 10),
      goals : math.zeros(10, 10),
      mode : "obstacle",
      agent_counter : 1,
      primed_goal : 0,
      ID : 0,
      blocking_confidences : [],
      agent_goals : math.matrix([[]]),
      agent_positions : math.matrix([[]]),
      rnn_states : math.matrix([[]]),
      state_init : math.matrix([math.zeros(1,512), math.zeros(1,512)]),
      GOALS : true,
      dirDict : {0:[0,0],1:[0,1],2:[1,0],3:[0,-1],4:[-1,0],5:[1,1],6:[1,-1],7:[-1,-1],8:[-1,1]},

      model_path : '',
      model_uploaded : false,
      model_status : 'no model',
      theme : 'light',
      map_loaded : "",

    }
  }